export default class CheckoutController {
    constructor($scope, sharedData) {
        'ngInject';

        this.$scope = $scope;
        this.sharedData = sharedData;

        this.cartItems = [];
    }

    $onInit() {
        this.cartItems = this.sharedData.cart.items;
    }
}